import React from "react";
import { useAppSelector } from "../app/hooks";
import CreateCity from "./city/CreateCity";
import CreateState from "./state/CreateState";
import CreateCountry from "./country/CreateCountry";
import CreateRights from "./rights/CreateRights";
import CreateMenu from "./menu/CreateMenu";
import AppDrawer from "../components/drawer/Drawer";
import CreateRegion from "./region/CreateRegion";
import CreateAirlineClass from "./airlineclass/CreateAirlineClass";
import CreateAirport from "./airport/CreateAirport";
import CreateCurrency from "./currency/CreateCurrency";
import CreateFlightPlace from "./flightplace/CreateFlightPlace";
import CreateFoodOption from "./foodoption/CreateFoodOption";
import CreateGst from "./gst/CreateGst";
import CreateHotelMapping from "./hotelmapping/CreateHotelMapping";
import CreateMealType from "./mealtype/CreateMealType";
import CreateNationality from "./nationality/CreateNationality";
import CreatePaxType from "./paxtype/CreatePaxType";
import CreateRoomCategory from "./roomcategory/CreateRoomCategory";
import CreateRoomType from "./roomtype/CreateRoomType";
import CreateRoute from "./route/CreateRoute";
import CreateSpecialityType from "./specialitytype/CreateSpecialityType";
import CreateTermsAndCondition from "./termsandcondition/CreateTermsAndCondition";
import CreateVehicleSharingPax from "./vehiclesharingpax/CreateVehicleSharingPax";
import CreateVendorType from "./vendortype/CreateVendorType";
import CreateVehicleType from "./vehicletype/CreateVehicleType";
import CreateFestivals from "./festival/CreateFestivals";
import CreateCancellationPolicy from "./companypolicy/CreateCancellationPolicy";
import CreateLeadSource from "./leadsource/CreateLeadSource";
import CreateLeadStage from "./leadstage/CreateLeadStage";
import CreateLead from "./lead/CreateLead";
import CreateItineraryFacility from "./ItineraryFacility/CreateItineraryFacility";
import CreateContact from "./contact/CreateContact";
import CreateTestimonial from "./testimonial/CreateTestimonial";
import CreateSetting from "./setting/CreateSetting";

const Drawers = () => {
  const isDrawerOpen = useAppSelector((state) => state.drawer.open);
  const drawerName = useAppSelector((state) => state.drawer.name);

  //   ***********Note : Here you need to add key as a drawerName same which you passed from create Button***********

  const drawerComponents: Record<string, React.JSX.Element> = {
    cityForm: <CreateCity />,
    countryForm: <CreateCountry />,
    stateForm: <CreateState />,
    rightsForm: <CreateRights />,
    menuForm: <CreateMenu />,
    regionForm: <CreateRegion />,
    // sectorForm: <CreateSector />,
    airlineClassForm: <CreateAirlineClass />,
    airportForm: <CreateAirport />,
    currencyForm: <CreateCurrency />,
    flightPlaceForm: <CreateFlightPlace />,
    foodOptionForm: <CreateFoodOption />,
    gstForm: <CreateGst />,
    hotelMappingForm: <CreateHotelMapping />,
    mealTypeForm: <CreateMealType />,
    nationalityform: <CreateNationality />,
    paxTypeForm: <CreatePaxType />,
    roomCategoryForm: <CreateRoomCategory />,
    roomTypeForm: <CreateRoomType />,
    routeForm: <CreateRoute />,
    specialityTypeForm: <CreateSpecialityType />,
    termsAndConditionForm: <CreateTermsAndCondition />,
    vehicleSharingPaxForm: <CreateVehicleSharingPax />,
    vendorTypeForm: <CreateVendorType />,
    vehicletypeForm: <CreateVehicleType />,
    festivalsForm: <CreateFestivals />,
    cancellationpolicyForm: <CreateCancellationPolicy />,
    leadsourceForm: <CreateLeadSource />,
    leadStageForm: <CreateLeadStage />,
    leadForm: <CreateLead />,
    contactForm: <CreateContact />,
    itineraryFacilityForm: <CreateItineraryFacility />,
    testimonialForm: <CreateTestimonial />,
    settingForm: <CreateSetting />,
  };

  return (
    <>
      {isDrawerOpen && Object.keys(drawerComponents).includes(drawerName) && (
        <AppDrawer>{drawerComponents[drawerName]}</AppDrawer>
      )}
    </>
  );
};

export default Drawers;
